import { Box, TextField } from "@mui/material";

export interface NotesFieldProps {
  value: string;
  onChange: (value: string) => void;
}

export function NotesField({ value, onChange }: NotesFieldProps) {
  return (
    <Box sx={{ mt: 1 }}>
      <TextField
        fullWidth
        size="small"
        className="notes-textfield"
        placeholder="Notizen hinzufügen..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </Box>
  );
}
